<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="!InProccessing">اطلاعات واریزی ها</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="InProccessing">اطلاعات واریزی ها (لطفا صبر نمائید ...)</h5>
      <br />
      <br />
      <button *ngIf="!InProccessing" (click)="exportexcel_Funds_Charge()" type="button" class="btn btn-warning"
        style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>مبلغ واریزی (ريال)</th>
              <th>تاریخ واریز</th>
              <th>شرح</th>
              <th>ایجاد کننده</th>
              <th>ناریخ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds_Charge
          | paginate
                  : {
                      id: 'DataList_UserTable_Charge',
                      itemsPerPage: 10,
                      currentPage: page_Charge,
                      totalItems: DataList_Funds_Charge.length
                    }
          ">
              <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.price | number}}</td>
              <td>{{item.price_date}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.username}}</td>
              <td>{{item.subdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Charge" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="page_Charge = $event"></pagination-controls>
    </div>
  </div>


  <div class="card card-statistics mb-30" style="margin-top: 10px;">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0" *ngIf="!InProccessing">اطلاعات هزینه های ثبت شده</h5>
      <h5 class="card-title border-0 pb-0" *ngIf="InProccessing">اطلاعات هزینه های ثبت شده (لطفا صبر نمائید ...)</h5>
      <br />
      <br />
      <button *ngIf="!InProccessing" (click)="exportexcel_Funds()" type="button" class="btn btn-warning"
        style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>نام مشتری</th>
              <th>شماره حکم</th>
              <th>مبلغ هزینه (ريال)</th>
              <th>تاریخ هزینه</th>
              <th>عنوان هزینه</th>
              <th>شرح</th>
              <th>فایل ضمیمه</th>
              <th>وضیعت</th>
              <th>ناریخ</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            | paginate
                    : {
                        id: 'DataList_UserTable_Pay',
                        itemsPerPage: 10,
                        currentPage: page_Pay,
                        totalItems: DataList_Funds.length
                      }
            ">
              <td>{{DataList_Funds.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.customer}}</td>
              <td>{{item.code2}}</td>
              <td>{{item.price | number}}</td>
              <td>{{item.price_date}}</td>
              <td>{{item.title}}</td>
              <td>{{item.dsc}}</td>
              <td>
                <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{item.src}}" *ngIf="item.src"><i
                    class="fa fa-download"></i> دانلود </a>
              </td>
              <td>
                <p *ngIf="item.status==0" style="color: #39539b;">در حال بررسی</p>
                <p *ngIf="item.status==1" style="color: 489b39;">تایید شد</p>
                <p *ngIf="item.status==-1" style="color: crimson;">رد شد</p>
              </td>
              <td>{{item.subdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination-controls id="DataList_UserTable_Pay" nextLabel="بعدی" previousLabel="قبلی"
        (pageChange)="page_Pay = $event"></pagination-controls>

    </div>
  </div>



  <table id="excel-table-charge" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>شناسه</th>
        <th>مبلغ واریزی (ريال)</th>
        <th>تاریخ واریز</th>
        <th>شرح</th>
        <th>ایجاد کننده</th>
        <th>ناریخ</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of DataList_Funds_Charge">
        <td>{{DataList_Funds_Charge.indexOf(item)+1}}</td>
        <td>{{item.code}}</td>
        <td>{{item.price | number}}</td>
        <td>{{item.price_date}}</td>
        <td>{{item.dsc}}</td>
        <td>{{item.username}}</td>
        <td>{{item.subdate}}</td>
      </tr>
    </tbody>
  </table>


  <table id="excel-table" style="display: none;">
    <thead>
      <tr>
        <th>#</th>
        <th>شناسه</th>
        <th>نام مشتری</th>
        <th>شماره حکم</th>
        <th>مبلغ هزینه (ريال)</th>
        <th>تاریخ هزینه</th>
        <th>عنوان هزینه</th>
        <th>شرح</th>
        <th>وضیعت</th>
        <th>ناریخ</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of DataList_Funds">
        <td>{{DataList_Funds.indexOf(item)+1}}</td>
        <td>{{item.code}}</td>
        <td>{{item.customer}}</td>
        <td>{{item.code2}}</td>
        <td>{{item.price | number}}</td>
        <td>{{item.price_date}}</td>
        <td>{{item.title}}</td>
        <td>{{item.dsc}}</td>
        <td>
          <p *ngIf="item.status==0" style="color: #39539b;">در حال بررسی</p>
          <p *ngIf="item.status==1" style="color: 489b39;">تایید شد</p>
          <p *ngIf="item.status==-1" style="color: crimson;">رد شد</p>
        </td>
        <td>{{item.subdate}}</td>
      </tr>
    </tbody>
  </table>